"use client";
import { createGlobalStyle } from "styled-components";
import AudiTypeNormal from "./AudiType-Normal_4.03.woff2.js";
import AudiTypeBold from "./AudiType-Bold_4.03.woff2.js";
import AudiTypeExtendedNormal from "./AudiType-ExtendedNormal_4.03.woff2.js";
import AudiTypeExtendedBold from "./AudiType-ExtendedBold_4.03.woff2.js";
const AudiFont = createGlobalStyle`

@font-face {
    font-family: 'Audi Type';
    src: url(${AudiTypeNormal});
    font-weight: 400;
}

@font-face {
    font-family: 'Audi Type';
    src: url(${AudiTypeBold});
    font-weight: 500;
}

@font-face {
    font-family: 'Audi Type Extended';
    src: url(${AudiTypeExtendedNormal});
    font-weight: 400;
}

@font-face {
    font-family: 'Audi Type Extended';
    src: url(${AudiTypeExtendedBold});
    font-weight: 500;
}
`;
export {
  AudiFont
};
